import { ClaimGroupMessages, TranslationClaimGroupMessages } from "../interfaces";

export const messages : TranslationClaimGroupMessages = {
  [ClaimGroupMessages.concreteBatchingPlant]: "Central de Concreto",
  [ClaimGroupMessages.gravel]: "Gravilla",
  [ClaimGroupMessages.supply]: "Insumo",
  [ClaimGroupMessages.characteristic]: "Característica",
  [ClaimGroupMessages.classification]: "Clasificación",
  [ClaimGroupMessages.supplier]: "Proveedor",
  [ClaimGroupMessages.concreteBatchingPlantGroup]: "Grupo de Central de Concreto",
  [ClaimGroupMessages.productGroup]: "Grupo de Producto",
  [ClaimGroupMessages.concreteRecipe]: "Producto",
  [ClaimGroupMessages.concreteBatchingPlantRegional]: "Regional de Central de Concreto",
  [ClaimGroupMessages.slump]: "Slump",
  [ClaimGroupMessages.measureUnitType]: "Tipo de Unidad de Medida",
  [ClaimGroupMessages.technicalDataSupply]: "Datos Técnicos",
  [ClaimGroupMessages.costSupply]: "Costo",
  [ClaimGroupMessages.abramsCurve]: "Curva de Abrams",
  [ClaimGroupMessages.concreteRecipeFamily]: "Familia de Receta de Concreto",
  [ClaimGroupMessages.copyInBatch]: "Copiar en Lote",
  [ClaimGroupMessages.changeInBatch]: "Cambiar en Lote",
  [ClaimGroupMessages.userRightsControl]: "Control de Derechos de Usuario",
  [ClaimGroupMessages.externalId]: "ID Externo",
  [ClaimGroupMessages.csvImport]: "Importar CSV",
  [ClaimGroupMessages.concreteMixDesignSheet]: "Hoja de Diseño de Mezcla de Concreto",
  [ClaimGroupMessages.concreteMixDesignSheetParameters]: "Parámetros de la Hoja de Diseño de Mezcla de Concreto",
  [ClaimGroupMessages.aggregateTest]: "Prueba de Agregado",
  [ClaimGroupMessages.aggregateTestReport]: "Informe de Prueba de Agregado",
  [ClaimGroupMessages.sieve]: "Tamiz",
  [ClaimGroupMessages.responsibleEngineer]: "Ingeniero Responsable",
  [ClaimGroupMessages.laboratory]: "Laboratorio",
  [ClaimGroupMessages.laboratoryTechnician]: "Técnico de Laboratorio",
  [ClaimGroupMessages.standard]: "Estándares",
  [ClaimGroupMessages.integrations]: "Integrações",
  [ClaimGroupMessages.vehicles]: "Vehículos",
  [ClaimGroupMessages.employees]: "Empleados",
  [ClaimGroupMessages.reports]: "Informes",
  [ClaimGroupMessages.generalParameters]: "Parámetros Generales",
  [ClaimGroupMessages.expedition]: "Expedición",
  [ClaimGroupMessages.aggregateMoisture]: "Humedad del Agregado",
  [ClaimGroupMessages.loadTickets]: "Tickets de Carga",
  [ClaimGroupMessages.deliveriesTickets]: "Tickets de Entrega",
  [ClaimGroupMessages.loadReuse]: "Reutilización de Carga",
  [ClaimGroupMessages.invoices]: "Facturas",
  [ClaimGroupMessages.weighingLink]: "Enlace de Pesaje",
  [ClaimGroupMessages.inventory]: "Inventario",
  [ClaimGroupMessages.inventoryClosure]: "Cierre de Inventario",
  [ClaimGroupMessages.dailyClosing]: "Cierre Diario",
  [ClaimGroupMessages.invoiceStub]: "Talón de Factura",
  [ClaimGroupMessages.approvalOfAdditionalFees]: "Aprobación de Cargos Adicionales",
  [ClaimGroupMessages.schedulings]: "Programaciones",
  [ClaimGroupMessages.concreteBatchingPlantGroupDispatch]: "Grupo de Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantRegionalDispatch]: "Regional de Central de Concreto",
  [ClaimGroupMessages.delivery]: "Entrega",
  [ClaimGroupMessages.reservation]: "Reserva",
  [ClaimGroupMessages.concreteBatchingPlantsDispatch]: "Centrales de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantGeneralParameters]: "Parámetros Generales de Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantOpeningHoursParameters]: "Parámetros de Horario de Apertura de Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantAverageDurationParameters]: "Parámetros de Duración Promedio de Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantMoldingParameters]: "Parámetros de Moldeo de Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantDailyClosingParameters]: "Parámetros de Cierre Diario de Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantTaxDocumentParameters]: "Parámetros de Documento Fiscal de Central de Concreto",
  [ClaimGroupMessages.loadingPoints]: "Puntos de Carga",
  [ClaimGroupMessages.loadingPointLocations]: "Ubicaciones de Puntos de Carga",
  [ClaimGroupMessages.deliveryRoutes]: "Rutas de Entrega",
  [ClaimGroupMessages.pumpingTypes]: "Tipos de Bombeo",
  [ClaimGroupMessages.piecesToBeConcreted]: "Piezas a Concretar",
  [ClaimGroupMessages.defaultDurationsByPumpingType]: "Duraciones Predeterminadas por Tipo de Bombeo",
  [ClaimGroupMessages.holidays]: "Feriados",
  [ClaimGroupMessages.reasons]: "Razones",
  [ClaimGroupMessages.taxConfigurationConcreteRecipe]: "Configuración de Impuestos de Receta de Concreto",
  [ClaimGroupMessages.users]: "Usuarios",
  [ClaimGroupMessages.groups]: "Grupos",
  [ClaimGroupMessages.alerts]: "Alertas",
  [ClaimGroupMessages.concreteDiscardDestination]: "Destino de descarte",
  [ClaimGroupMessages.loadTicketBlockReason]: "Razón de bloqueo de ticket de carga",
  [ClaimGroupMessages.pumpingBlockReason]: "Razón de bloqueo de bombeo",
  [ClaimGroupMessages.batchMaintenanceView]: "Visualización de Tareas de Mantenimiento",
  [ClaimGroupMessages.batchMaintenanceEdit]: "Edición de Tareas de Mantenimiento",
  [ClaimGroupMessages.batchMaintenanceExecute]: "Ejecución de Tareas de Mantenimiento",
  [ClaimGroupMessages.batchAutomationView]: "Visualización de Automatización",
  [ClaimGroupMessages.batchAutomationExecute]: "Ejecución de Automatización",
  [ClaimGroupMessages.batchAutomationAdmin]: "Administración de Automatización",
  [ClaimGroupMessages.batchAutomationSuperAdmin]: "Súper Administración de Automatización",
  [ClaimGroupMessages.dailyProductionClosingInconsistencies]: "Inconsistencias en el cierre de la producción diaria",
  [ClaimGroupMessages.timeRecords]: "Mantenimiento de Puntos",
  [ClaimGroupMessages.timeClockConfigurations]: "Configuración del Reloj de Punto",
  [ClaimGroupMessages.performance]: "Indicadores de Rendimiento (KPIs)",
  [ClaimGroupMessages.laboratoryModule]: "Acceso al laboratorio",
  [ClaimGroupMessages.specimenCollection]: "Recolección de probetas",
  [ClaimGroupMessages.specimenRupture]: "Rotura de probetas",
  [ClaimGroupMessages.deliveryTicketSpecimens]: "Panel de remesas/muestras",
  [ClaimGroupMessages.collectionSchedule]: "Agenda de recolección",
  [ClaimGroupMessages.ruptureSchedule]: "Agenda de rotura",
  [ClaimGroupMessages.issueCertificate]: "Emitir certificado",
  [ClaimGroupMessages.issuedCertificates]: "Certificados emitidos",
  [ClaimGroupMessages.presses]: "Prensas",
  [ClaimGroupMessages.certificateParameters]: "Parámetros del certificado de resistencia",
  [ClaimGroupMessages.laboratoryStatistics]: "Estadísticas del laboratorio",
  [ClaimGroupMessages.lowStrengthApproval]: "Aprobación de resistencias bajas"
};
